<template>
  <div>
    <el-form ref="formRef" :model="voucherSysForm" label-width="180px">
      <el-form-item label="平台：">
        <el-radio-group v-model="platformType">
          <el-radio :label="1" size="large">安卓</el-radio>
          <el-radio :label="4" size="large">鸿蒙</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="代金券名称：">
        <el-input v-model="voucherSysForm.name" placeholder="20个字以内" style="width:22em;" :maxlength="20"/>
      </el-form-item>
      <el-form-item label="代金券金额：">
        <el-input v-model="voucherSysForm.price" :maxlength="4" placeholder="1000以内的正整数" style="width:22em;margin-right: 8px;"/>
        元
      </el-form-item>
      <el-form-item label="可用类型：">
        <el-select v-model="useType" placeholder="请选择">
          <el-option
              v-for="item in useTypeArray"
              :key="item.value"
              :label="item.label"
              :value="item.label">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="最低购买金额：">
        <el-input v-model="voucherSysForm.minPay" style="width:22em;margin-right: 8px;" :maxlength="4" placeholder="请输入最低购买金额" :disabled="isAllMinPay"></el-input>
        <el-checkbox v-model="isAllMinPay">不限金额</el-checkbox>
      </el-form-item>
      <el-form-item label="有效期：">
        <el-input v-model="effectiveValue"  style="width:22em; margin-right: 8px;" :maxlength="3" placeholder="请输入有效期"></el-input>
        <el-select v-model="effectiveType" value-key="value" placeholder="请选择" style="width: 6em;">
          <el-option v-for="item in effectiveTypeArray" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div class="dialog-footer" style="text-align: center">
      <el-button @click.native="cancel" >取消</el-button>
      <el-button type="primary" @click="summit" v-loading="loading">确定</el-button>
    </div>
  </div>

</template>

<script>
import { postFormData } from "@/api/api"
import { addOrUpdateVoucherSys } from "@/api/url";
import { positiveIntReg } from "@/assets/shared/reg-constant";

export default {
  name: "TagManageDialog",
  props: {
    value: Object
  },
  data() {
    return {
      voucherSysForm: this.value.voucherSysForm,
      idx: this.value.ids,
      submitLoading: false,

      platformType: this.value.ids > -1? this.value.voucherSysForm.platformType: 1,

      useTypeArray: [
        {label: "不限", useType: 0, useTypeNum: -1},
        {label: "开通SVIP服务", useType: 10, useTypeNum: -1},
        {label: "金币购买", useType: 1, useTypeNum: -1},
        {label: "开通VIP服务", useType: 2, useTypeNum: -1},
        {label: "开通1个月VIP", useType: 2, useTypeNum: 1},
        {label: "开通3个月VIP", useType: 2, useTypeNum: 3},
        {label: "开通6个月VIP", useType: 2, useTypeNum: 6},
        {label: "开通1年VIP", useType: 2, useTypeNum: 12},
        {label: "开通终身VIP", useType: 2, useTypeNum: 0},
        {label: "申请婚恋专属服务", useType: 3, useTypeNum: -1},
        {label: "申请3个月婚恋专属服务", useType: 3, useTypeNum: 3},
        {label: "申请6个月婚恋专属服务", useType: 3, useTypeNum: 6},
        {label: "申请1年婚恋专属服务", useType: 3, useTypeNum: 12},
        {label: "申请3年婚恋专属服务", useType: 3, useTypeNum: 36}
      ],
      useType: "不限",
      isAllMinPay: false,
      effectiveTypeArray: [
        {label: '天', value: 1},
        {label: '分钟', value: 2}
      ],
      effectiveType: this.value.voucherSysForm.effectiveDay != 0?1:2,
      effectiveValue: this.value.voucherSysForm.effectiveDay != 0?this.value.voucherSysForm.effectiveDay:this.value.voucherSysForm.effectiveMinute,

    }
  },
  methods: {
    cancel() {
      this.$emit("close");
    },

    //更改或添加
    headImgUpdate() {
      this.$refs.headImg.click();
    },

    //选取图片
    headImgChanged(e) {
      if(e.target.files[0]) {
        this.files = e.target.files[0];
        var windowURL = window.URL || window.webkitURL;
        this.src = windowURL.createObjectURL(this.files);
      }
    },

    summit() {
      if ((!this.voucherSysForm.name && this.voucherSysForm.name != 0) || (!this.voucherSysForm.price && this.voucherSysForm.price != 0) || (!this.voucherSysForm.minPay && this.voucherSysForm.minPay != 0 && !this.isAllMinPay) || (!this.effectiveValue && this.effectiveValue != 0) || (this.voucherSysForm.minPay == '' && !this.isAllMinPay)) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: "所有项不能为空",
          type: 'warning'
        });
      }else{
        if(!positiveIntReg.test(this.voucherSysForm.price) || this.voucherSysForm.price > 1000){
          this.$message({
            showClose: true,
            duration: 2000,
            message: "代金券金额是1000以内的正整数",
            type: 'warning'
          });
        }else if(!this.isAllMinPay && !positiveIntReg.test(this.voucherSysForm.minPay)){
          this.$message({
            showClose: true,
            duration: 2000,
            message: "最低购买金额需要为正整数",
            type: 'warning'
          });
        }else if(!positiveIntReg.test(this.effectiveValue)){
          this.$message({
            showClose: true,
            duration: 2000,
            message: "有效期需要为正整数",
            type: 'warning'
          });
        }else{
          this.sumbitVoucherSys();
        }
      }
    },

    sumbitVoucherSys() {
      let _this = this;
      let use_type = '';
      let use_type_num = '';
      this.submitLoading = true;
      this.useTypeArray.forEach((e) => {
        if(this.useType == e.label){
          use_type = e.useType;
          use_type_num = e.useTypeNum;
        }
      })
      if(this.isAllMinPay){
        this.voucherSysForm.minPay = 0;
      }
      let param = {};
      param['id'] = this.idx> -1?this.voucherSysForm.id:0;
      param['name'] = this.voucherSysForm.name;
      param['price'] = this.voucherSysForm.price;
      param['minPay'] = this.voucherSysForm.minPay;
      if(this.effectiveType == 1) {
        param['effectiveDay'] = this.effectiveValue;
        param['effectiveMinute'] = 0
      }
      if(this.effectiveType == 2) {
        param['effectiveDay'] = 0;
        param['effectiveMinute'] = this.effectiveValue
      }
      param['useType'] = Number(use_type);
      param['useTypeNum'] = Number(use_type_num);
      param['platformType'] = this.platformType;
      postFormData(addOrUpdateVoucherSys, param).then(function(data){
        let {code,msg} = data;
        if(code == 200){
          _this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'success'
          });
          _this.$emit('confirm')
        }else{
          _this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          });
        }

        _this.submitLoading = false;
      })
          .catch(function(response){
            _this.submitLoading = false;
          })
    }

  },
  created() {
    if(this.idx > -1) {
      this.useTypeArray.forEach((e) => {
        if(e.useType == this.voucherSysForm.useType && e.useTypeNum == this.voucherSysForm.useTypeNum){
          this.useType = e.label;
        }
      })
      if(!this.value.voucherSysForm.minPay || this.value.voucherSysForm.minPay == 0){
        this.isAllMinPay = true;
      }
    }
  },
  mounted() {

  }
}
</script>

<style scoped>
.add {
  width: 80px;
  height: 80px;
  text-align: center;
  line-height: 80px;
  border: 1px dashed #ececec;
  font-size: 30px;
  cursor: pointer;
  float: left;
}
</style>
